import { useNavigate, useSearchParams } from "react-router-dom";
import KakaoTalk from "../../assets/images/payment/kakao_LOGO-07.png";
import {
  KAKAO_CHANNEL_URL,
  KAKAO_CHANNEL_NAME,
  PREMIUM_MANSEOL_PRICE,
} from "../../utils/constants";
import Footer from "../../components/Footer";
import paymentHeader from "../../assets/images/payment/payment_header.webp";
import { getSaju } from "../../framework/api";
import { useEffect } from "react";
import {
  convertTimeToTwelveTime,
  formatBirthDate,
  formatTime,
} from "../../utils/timeConvert";
import CustomerCenterButton from "../../components/CustomerCenterButton";

// leap, gender 변환 유틸
function getLeapText(leap: string) {
  if (leap === "SOLAR") return "양력";
  if (leap === "LUNAR") return "음력";
  if (leap === "LEAP") return "윤달";
  return leap || "-";
}

function getGenderText(gender: string) {
  if (gender === "MALE") return "남";
  if (gender === "FEMALE") return "여";
  return gender || "-";
}

// 사주 정보 요약 컴포넌트
function SajuInfoBox({
  name,
  sajuInfo,
  leapText,
  genderText,
}: {
  name: string;
  sajuInfo: string;
  leapText: string;
  genderText: string;
}) {
  return (
    <div className="gap-2 py-2 border-b-[0.5px] border-[#0F0C1640]">
      <span className="font-extrabold w-20">사주 정보</span>
      <div className="flex gap-2">
        <div>
          <div className="w-24 text-right font-bold text-sm">
            <p>이름 :</p>
            <p>년월일시 :</p>
            <p>양,음,윤 :</p>
            <p>성별 :</p>
          </div>
        </div>
        <div className="flex flex-col text-sm">
          <p>{name}</p>
          <p>{sajuInfo}</p>
          <p>{leapText}</p>
          <p>{genderText}</p>
        </div>
      </div>
    </div>
  );
}

// 결제 정보 요약 컴포넌트
function PaymentInfoBox({
  phoneNumber,
  email,
}: {
  phoneNumber: string;
  email?: string;
}) {
  return (
    <div className="flex gap-2 py-2 border-b-[0.5px] border-[#0F0C1640]">
      <div>
        <span className="font-extrabold w-20">결제 정보</span>
        <div className="w-24 text-right font-bold text-sm">
          <p>금액 :</p>
          <p>휴대폰 :</p>
          <p>이메일 :</p>
        </div>
      </div>
      <div className="flex flex-col gap-1 text-sm">
        <span>카드결제</span>
        <div>
          <p>{PREMIUM_MANSEOL_PRICE.toLocaleString()}원</p>
          <p>{phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")}</p>
          <p>{email || "입력되지 않음"}</p>
        </div>
      </div>
    </div>
  );
}

// 문의 정보 컴포넌트
function InquiryBox() {
  return (
    <div className="flex items-start py-2">
      <span className="font-extrabold w-24">문의</span>
      <a
        href={KAKAO_CHANNEL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-start gap-2"
      >
        <img src={KakaoTalk} alt="카카오톡채널" className="w-12 h-12 -m-2" />
        <span className="text-sm leading-[120%]">
          카카오톡 채널
          <br />'{KAKAO_CHANNEL_NAME}'
        </span>
      </a>
    </div>
  );
}

function PaymentCompletePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // URL 파라미터에서 정보 추출
  const productType = searchParams.get("productType") || "";
  const phoneNumber = searchParams.get("phone") || "";
  const email = searchParams.get("email") || "";
  const birth = searchParams.get("birth") || "";
  const time = searchParams.get("time") || "";
  const leap = searchParams.get("leap") || "";
  const gender = searchParams.get("gender") || "";
  const question = searchParams.get("question") || "";
  const paymentId = searchParams.get("paymentId") || "";
  const transactionType = searchParams.get("transactionType") || "";
  const txId = searchParams.get("txId") || "";
  const code = searchParams.get("code");
  const message = searchParams.get("message");
  const name = searchParams.get("name") || "";

  const combinedInfo = {
    name: name,
    phone: phoneNumber,
    email: email,
    birth: birth,
    time: time,
    leap: leap,
    gender: gender,
    question: question,
    paymentId: paymentId,
    transactionType: transactionType,
    txId: txId,
  };
  console.log("combinedInfo::", combinedInfo);

  // 서버에 combinedInfo 전송, 근데 한번만 해야함. 만약 사용자가 새로고침하면 어떻게 해야하지?

  // useEffect(() => {
  //   function postPaymentInfo() {
  //     getSaju.post("/mobile/payment", {
  //       productType: productType,
  //       paymentType: "card",
  //       birthday: formatBirthDate(birth),
  //       birthdayType: leap.toUpperCase(),
  //       gender: gender.toUpperCase(),
  //       time: formatTime(time),
  //       phone: phoneNumber.replace(/[^0-9]/g, ""),
  //       question: question,
  //       paymentUid: paymentId,
  //       ...(productType === "video" ? { email: email || "" } : {}),
  //       txId: txId,
  //       txType: "string",
  //     });
  //   }
  //   postPaymentInfo();
  // }, []);
  // 결제정보 객체
  const paymentInfo = {
    productType,
    phoneNumber,
    name,
    email,
    birth,
    time,
    leap,
    gender,
    question,
    paymentId,
    transactionType,
    txId,
  };

  useEffect(() => {
    if (paymentId && !code) {
      const lastPaymentId = sessionStorage.getItem("lastPaymentId");
      if (lastPaymentId !== paymentId) {
        // 새 결제일 때만 API 호출
        getSaju
          .post("/mobile/payment", {
            productType: productType,
            paymentType: "card",
            name: name,
            birthday: formatBirthDate(birth),
            birthdayType: leap.toUpperCase(),
            gender: gender.toUpperCase(),
            time: formatTime(time),
            phone: phoneNumber.replace(/[^0-9]/g, ""),
            question: question,
            paymentUid: paymentId,
            ...(productType === "video" ? { email: email || "" } : {}),
            txId: txId,
            txType: "string",
          })
          .catch((e) => {
            console.log("결제 실패:", e);
          });
        // 세션에 paymentId와 결제 정보 저장
        sessionStorage.setItem("lastPaymentId", paymentId);
        sessionStorage.setItem(
          "paymentCompleteInfo",
          JSON.stringify(paymentInfo)
        );
      }
      // 파라미터 제거(리다이렉트)
      //navigate("/payment/complete", { replace: true });
    } else {
      // 파라미터 없으면 세션에서 정보 조회
      const saved = sessionStorage.getItem("paymentCompleteInfo");
      if (!saved) {
        navigate("/payment", { replace: true });
      }
      // 있으면 화면만 렌더(API 호출 X)
    }
  }, []);

  const handleGoToMain = () => navigate("/payment");

  const sajuInfo = `${birth}${time ? ` ${convertTimeToTwelveTime(time)}` : ""}`;
  const leapText = getLeapText(leap);
  const genderText = getGenderText(gender);

  // 이메일이 있으면 영상 상담, 없으면 전화 상담으로 판단
  const isVideoRoute = !!email;

  return (
    <div className="min-h-screen flex flex-col  mx-auto bg-[#F9F9FC]">
      <header className="w-full max-w-[716px] mx-auto">
        <img src={paymentHeader} alt="logo" className="w-full" />
      </header>

      {code ? (
        <main className="flex-1 flex flex-col items-center bg-[#F9F9FC] mx-auto mb-10 mt-10">
          <h2 className="text-2xl font-bold mb-8">결제 실패</h2>
          <h2 className="text-2xl font-regular mb-2">
            결제를 완료하지 못했습니다.
          </h2>
          <div className="text-center text-base mb-4 text-red-500">
            이유: {message}
          </div>
          <button
            className="w-full max-w-[320px] h-12 rounded-lg text-xl font-extrabold border shadow-sm hover:bg-[#ede6ff] transition-all bg-[#9D7FDE] hover:bg-[#9D7FDE]/80 text-white"
            onClick={handleGoToMain}
          >
            처음으로 돌아가기
          </button>
          <CustomerCenterButton className="mt-10" />
        </main>
      ) : (
        <main className="flex-1 flex flex-col items-center bg-[#F9F9FC] mx-auto mb-10 mt-10">
          <h2 className="text-2xl font-bold mb-8">결제 완료</h2>
          {isVideoRoute ? (
            <div className="text-center text-base mb-4">
              결제가 완료되었습니다.
              <br />
              이메일에 24시간 이내로 사주 영상이 전송될 예정입니다.
            </div>
          ) : (
            <div className="text-center text-base mb-4">
              상담하고 싶은 시간을{" "}
              <span className="font-bold">카카오톡 채널</span>
              로 보내주세요
              <br />
              <span className="text-xs text-[#666]">
                (카카오톡 채널로 연락을 주셔야 시간 예약이 가능합니다)
              </span>
            </div>
          )}
          <div className="w-full bg-[#F3F3F3] max-w-[320px] rounded-md shadow-md px-5 py-4 mb-8 text-base text-[#222] flex flex-col border border-[#eee]">
            <SajuInfoBox
              name={name}
              sajuInfo={sajuInfo}
              leapText={leapText}
              genderText={genderText}
            />
            <PaymentInfoBox phoneNumber={phoneNumber} email={email} />
            <InquiryBox />
          </div>
          {/* 전화상담 예약 버튼 */}
          {!isVideoRoute && (
            <button
              className="w-full max-w-[320px] h-12 rounded-lg bg-[#B39DDB] text-white text-xl font-extrabold mb-3 shadow-md hover:brightness-95 transition-all"
              onClick={() => window.open(KAKAO_CHANNEL_URL, "_blank")}
            >
              전화상담 예약하기
            </button>
          )}
          {/* 처음으로 돌아가기 버튼 */}
          <button
            className={`w-full max-w-[320px] h-12 rounded-lg text-xl font-extrabold border shadow-sm hover:bg-[#ede6ff] transition-all ${
              isVideoRoute
                ? "bg-[#B39DDB] hover:bg-[#B39DDB]/80 text-white"
                : "bg-[#F3EDFF] border-[#9D7FDE] text-[#222] hover:bg-[#ede6ff]"
            }`}
            onClick={handleGoToMain}
          >
            처음으로 돌아가기
          </button>
        </main>
      )}
      <Footer />
    </div>
  );
}

export default PaymentCompletePage;
